module.exports = __webpack_public_path__ + "img/atmosphere02.2b3c4cc5.png";